// Module
var code = "<mm-card caption=\"'Entities.UserInformation.Password'\" sub-caption=\"\" icon=\"'key'\" edit=\"$ctrl.editPassword()\" is-loading=\"$ctrl.isLoading\"></mm-card> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Auth/Components/Profile/Password/ProfilePassword.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;